import AdminView4MTable from "./AdminView4MTable";
export default AdminView4MTable;
